import HiristAppIconNew from './app-icon.svg';
import HiristTextLogoWhiteNew from './text-logo-white.svg';

export {HiristAppIconNew, HiristTextLogoWhiteNew};
